import { authorizeMe, axiosInstance } from "./commonHeadApiLogic.js";

// wrapper already defined by you
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};


export const getSidebarAPI = () => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/sidebar-icons`
    );
  });
};



